module.exports = __webpack_public_path__ + "img/90a825a.png";